import React, { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_KEY = 'Vjh5y6yEaj6YDSqPl4uoB8iYl5KAmbkY8Bl9kZRr'; // ✅ API Key adicionada

const questionnaireData = [
  {
    id: "energy_management",
    title: "1. Gestão de Energia",
    pillar: "Ambiental (E)",
    questions: [
      "Sua empresa monitora o consumo de energia elétrica?",
      "Há metas definidas para redução do consumo energético?",
      "A empresa utiliza iluminação LED ou outras tecnologias de eficiência energética?",
      "Existem políticas para desligar equipamentos fora do expediente?",
      "A empresa investe ou planeja investir em energia renovável (solar, eólica)?",
    ],
  },
  {
    id: "resources_waste",
    title: "2. Consumo de Recursos e Resíduos",
    pillar: "Ambiental (E)",
    questions: [
      "A empresa possui sistema de coleta seletiva implementado?",
      "Há controle sobre o consumo de papel e incentivo à digitalização?",
      "Existe gestão adequada do descarte de resíduos eletrônicos?",
      "A empresa tem parcerias com empresas de reciclagem?",
      "Há metas de redução de geração de resíduos?",
    ],
  },
  {
    id: "sustainable_work",
    title: "3. Modelo de Trabalho Sustentável",
    pillar: "Ambiental (E)",
    questions: [
      "A empresa adota trabalho híbrido ou remoto como política oficial?",
      "Há monitoramento da redução de emissões de CO₂ por diminuição de deslocamentos?",
      "Existe política de incentivo ao uso de transporte sustentável (bicicleta, transporte público)?",
      "A empresa mensura sua pegada de carbono?",
      "Há compensação de emissões através de projetos ambientais?",
    ],
  },
  {
    id: "supply_chain",
    title: "4. Cadeia de Suprimentos Sustentável",
    pillar: "Ambiental (E)",
    questions: [
      "A empresa seleciona fornecedores com base em critérios ambientais?",
      "Há preferência por fornecedores com certificações ambientais?",
      "A empresa usa materiais sustentáveis ou reciclados em suas operações?",
      "Existe avaliação periódica das práticas ambientais dos fornecedores?",
      "A empresa participa de iniciativas de economia circular?",
    ],
  },
  {
    id: "health_safety",
    title: "5. Saúde, Segurança e Bem-estar",
    pillar: "Social (S)",
    questions: [
      "A empresa oferece benefícios relacionados à saúde (plano de saúde, ginástica laboral, apoio psicológico)?",
      "Há políticas claras de prevenção ao burnout e gestão de saúde mental?",
      "Existe responsável pela segurança do trabalho e EPIs adequados?",
      "A empresa realiza avaliações periódicas de clima organizacional?",
      "Há flexibilidade de horários para questões pessoais dos colaboradores?",
    ],
  },
  {
    id: "diversity",
    title: "6. Diversidade, Equidade e Inclusão (DEI)",
    pillar: "Social (S)",
    questions: [
      "A empresa possui processos seletivos estruturados para atrair talentos diversos?",
      "Há representatividade de diferentes grupos (gênero, raça, idade, PCD, LGBTQIAP+) na equipe?",
      "Existem treinamentos sobre diversidade e combate ao preconceito?",
      "A empresa possui políticas de equidade salarial?",
      "Há infraestrutura acessível para pessoas com deficiência?",
    ],
  },
  {
    id: "development",
    title: "7. Desenvolvimento e Valorização de Pessoas",
    pillar: "Social (S)",
    questions: [
      "A empresa oferece programas de treinamento e capacitação?",
      "Existe plano de carreira estruturado?",
      "Há avaliações de desempenho periódicas com feedback construtivo?",
      "A empresa investe em educação continuada dos colaboradores?",
      "Existe programa de reconhecimento e recompensa?",
    ],
  },
  {
    id: "community",
    title: "8. Relacionamento com Clientes e Comunidade",
    pillar: "Social (S)",
    questions: [
      "A empresa possui canal estruturado de atendimento ao cliente?",
      "Há conformidade total com a LGPD na proteção de dados?",
      "A empresa realiza pesquisas de satisfação regularmente?",
      "Existem iniciativas de voluntariado corporativo?",
      "A empresa apoia projetos sociais ou ONGs locais?",
    ],
  },
  {
    id: "ethics",
    title: "9. Ética e Transparência",
    pillar: "Governança (G)",
    questions: [
      "A empresa possui Código de Conduta e Ética documentado?",
      "Existe política anticorrupção e antissuborno clara?",
      "Há comunicação transparente sobre resultados e decisões estratégicas?",
      "A empresa possui canal de denúncias anônimo?",
      "Existe pessoa ou comitê responsável por analisar denúncias éticas?",
    ],
  },
  {
    id: "controls",
    title: "10. Controles Internos e Gestão de Riscos",
    pillar: "Governança (G)",
    questions: [
      "A empresa possui processos financeiros documentados e auditáveis?",
      "Há separação clara de funções e alçadas de aprovação?",
      "Existe mapeamento dos principais riscos do negócio (incluindo ESG)?",
      "A empresa realiza auditorias internas periódicas?",
      "Há plano de continuidade de negócios documentado?",
    ],
  },
  {
    id: "data_security",
    title: "11. Segurança da Informação e LGPD",
    pillar: "Governança (G)",
    questions: [
      "A empresa possui política de segurança da informação documentada?",
      "Há conformidade comprovada com a LGPD?",
      "Existe DPO (Data Protection Officer) ou responsável pela proteção de dados?",
      "Há treinamentos regulares sobre segurança da informação?",
      "A empresa utiliza ferramentas adequadas de armazenamento seguro de dados?",
    ],
  },
  {
    id: "governance_structure",
    title: "12. Estrutura de Governança",
    pillar: "Governança (G)",
    questions: [
      "A empresa possui estrutura societária clara e documentada?",
      "Há definição clara de papéis, responsabilidades e hierarquia?",
      "Existem reuniões periódicas de governança documentadas?",
      "A empresa possui conselho consultivo ou advisory board?",
      "Há indicadores de performance (KPIs) definidos e acompanhados?",
    ],
  },
  {
    id: "measurement",
    title: "13. Mensuração e Reporte",
    pillar: "Comunicação ESG",
    questions: [
      "A empresa possui indicadores (KPIs) ESG definidos?",
      "Há monitoramento regular dos resultados das iniciativas ESG?",
      "A empresa produz relatórios de sustentabilidade ou ESG?",
      "Existem metas ESG de curto, médio e longo prazo?",
      "Os resultados ESG são comunicados ao mercado/stakeholders?",
    ],
  },
  {
    id: "engagement",
    title: "14. Engajamento e Cultura",
    pillar: "Comunicação ESG",
    questions: [
      "Os colaboradores são treinados sobre a importância do ESG?",
      "Há campanhas internas de conscientização sobre ESG?",
      "A liderança demonstra comprometimento visível com ESG?",
      "As práticas ESG são comunicadas no site/redes sociais da empresa?",
      "Existe orçamento dedicado para iniciativas ESG?",
    ],
  },
];

const Dashboard = ({ userData, onClearData }) => {
  const [answers, setAnswers] = useState({
    energy_management: [],
    resources_waste: [],
    sustainable_work: [],
    supply_chain: [],
    health_safety: [],
    diversity: [],
    development: [],
    community: [],
    ethics: [],
    controls: [],
    data_security: [],
    governance_structure: [],
    measurement: [],
    engagement: [],
  });

  const [impactAnswers, setImpactAnswers] = useState({
    impact_question_1: false,
    impact_question_2: false,
    impact_question_3: false,
  });

  const [loading, setLoading] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [result, setResult] = useState(null);

  const handleCheckboxChange = (sectionId, questionIndex) => {
    setAnswers((prev) => {
      const currentAnswers = prev[sectionId];
      const isChecked = currentAnswers.includes(questionIndex);

      return {
        ...prev,
        [sectionId]: isChecked
          ? currentAnswers.filter((idx) => idx !== questionIndex)
          : [...currentAnswers, questionIndex],
      };
    });
  };

  const handleImpactChange = (field) => {
    setImpactAnswers((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const calculateTotalScore = () => {
    return Object.values(answers).reduce(
      (sum, sectionAnswers) => sum + sectionAnswers.length,
      0
    );
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      // Prepare complete payload with user data + questionnaire
      const payload = {
        user_data: userData,
        questionnaire: {
          ...answers,
          ...impactAnswers,
        }
      };

      const response = await axios.post(
        BACKEND_URL,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': API_KEY  // ✅ API Key adicionada nos headers
          }
        }
      );

      setResult(response.data);
      setShowResult(true);
    } catch (err) {
      const errorDetail = err.response?.data?.detail;
      
      alert(
        "Erro ao enviar questionário: " +
          (errorDetail || "Tente novamente")
      );
    } finally {
      setLoading(false);
    }
  };

  const totalScore = calculateTotalScore();

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <div className="dashboard-header-content">
          <h1 className="dashboard-title" data-testid="dashboard-title">ESG Assessment</h1>
          <button className="logout-btn" onClick={onClearData} data-testid="logout-btn">
            Sair
          </button>
        </div>
      </header>

      <div className="dashboard-content">
        <div className="welcome-card" data-testid="welcome-card">
          <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: "0.5rem" }}>
            Olá, {userData?.name}!
          </h2>
          <p style={{ color: "#666", fontSize: "0.95rem" }}>
            Complete o questionário abaixo para avaliar a maturidade ESG da sua empresa.
          </p>
        </div>

        <div className="questionnaire-card">
          <div className="section-title" data-testid="questionnaire-title">Questionário de Maturidade ESG</div>
          <div className="section-description">
            Responda às perguntas abaixo de forma honesta. Marque as práticas que sua
            empresa já possui implementadas.
          </div>

          {questionnaireData.map((section) => (
            <div key={section.id} className="questionnaire-section" data-testid={`section-${section.id}`}>
              <div className="section-header">
                <div className="section-label">{section.title}</div>
                <div className="section-score">
                  {section.pillar} • {answers[section.id].length}/5 pontos
                </div>
              </div>

              <div className="questions-list">
                {section.questions.map((question, index) => (
                  <div key={index} className="question-item" data-testid={`question-${section.id}-${index}`}>
                    <input
                      type="checkbox"
                      className="question-checkbox"
                      checked={answers[section.id].includes(index)}
                      onChange={() => handleCheckboxChange(section.id, index)}
                      data-testid={`checkbox-${section.id}-${index}`}
                    />
                    <label className="question-text">{question}</label>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div className="impact-section" data-testid="impact-section">
            <div className="section-label" style={{ marginBottom: "1rem" }}>
              15. Geração de Impacto
            </div>
            <div className="questions-list">
              <div className="question-item" data-testid="impact-question-0">
                <input
                  type="checkbox"
                  className="question-checkbox"
                  checked={impactAnswers.impact_question_1}
                  onChange={() => handleImpactChange("impact_question_1")}
                  data-testid="checkbox-impact-question-1"
                />
                <label className="question-text">
                  O seu negócio busca resolver um problema social ou ambiental específico?
                </label>
              </div>
              <div className="question-item" data-testid="impact-question-1">
                <input
                  type="checkbox"
                  className="question-checkbox"
                  checked={impactAnswers.impact_question_2}
                  onChange={() => handleImpactChange("impact_question_2")}
                  data-testid="checkbox-impact-question-2"
                />
                <label className="question-text">
                  A geração de impacto positivo faz parte do modelo central do negócio, e não apenas como um resultado secundário?
                </label>
              </div>
              <div className="question-item" data-testid="impact-question-2">
                <input
                  type="checkbox"
                  className="question-checkbox"
                  checked={impactAnswers.impact_question_3}
                  onChange={() => handleImpactChange("impact_question_3")}
                  data-testid="checkbox-impact-question-3"
                />
                <label className="question-text">
                  Você já mensura, ou pretende mensurar, os resultados sociais e ambientais gerados pela sua atuação?
                </label>
              </div>
            </div>
          </div>

          <div className="submit-section">
            <div
              style={{
                fontSize: "1.25rem",
                fontWeight: 600,
                marginBottom: "1rem",
                color: "#1a1a1a",
              }}
              data-testid="total-score-display"
            >
              Pontuação Total: {totalScore}/70
            </div>
            <button
              className="submit-btn"
              onClick={handleSubmit}
              disabled={loading}
              data-testid="submit-questionnaire-btn"
            >
              {loading ? "Enviando..." : "Enviar Questionário"}
            </button>
          </div>
        </div>
      </div>

      {showResult && result && (
        <div className="result-modal-overlay">
          <div className="result-modal" onClick={(e) => e.stopPropagation()} data-testid="result-modal">
            <div className="result-icon">✓</div>
            <h2 className="result-title">Questionário Enviado!</h2>
            <p style={{ color: "#666", marginBottom: "1.5rem" }}>
              Sua avaliação foi concluída com sucesso.
            </p>
            <div className="result-score" data-testid="result-score">{result.total_score}/70</div>
            <div className="result-level" data-testid="result-level">Nível: {result.maturity_level}</div>
            
            {result.impact_message && (
              <div 
                style={{ 
                  margin: "1.5rem 0",
                  padding: "1.25rem",
                  background: "#f0fdf4",
                  borderRadius: "12px",
                  borderLeft: "4px solid #22c55e"
                }}
                data-testid="impact-message"
              >
                <p style={{ 
                  color: "#166534", 
                  fontSize: "0.95rem", 
                  lineHeight: "1.6",
                  margin: 0,
                  fontWeight: 500
                }}>
                  {result.impact_message}
                </p>
              </div>
            )}
            
            <div 
              style={{ 
                margin: "1.5rem 0",
                padding: "1rem",
                background: "#f8fafc",
                borderRadius: "10px",
                border: "1px solid #e2e8f0"
              }}
              data-testid="email-notification-message"
            >
              <p style={{ 
                color: "#334155", 
                fontSize: "0.9rem", 
                lineHeight: "1.5",
                margin: 0,
                textAlign: "center"
              }}>
                📧 Você vai receber o relatório com o diagnóstico completo no e-mail cadastrado dentro de 48h.
              </p>
            </div>
            
            <button 
              className="result-close-btn" 
              onClick={() => {
                onClearData();
                window.location.href = "https://bhtec.org.br/";
              }} 
              data-testid="close-result-btn"
            >
              Fechar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;